import { getSinceThreeMonth,getRecentOneMonth,getRecentSevenDay} from '@/libs/date';
import { fetchGet } from "@/libs/reqCommon";
const createProp=(data)=>{
    let arr=[]
    for(let key in data){
        if(data[key]=='date'){
            arr.unshift({
                prop:data[key],
                label:key
            })
        }else{
            arr.push({
                prop:data[key],
                label:key
            })
        }                       
    }
    return arr
}
const timeSort=(arr,prop)=>{
    return arr.sort((a, b) => b[prop]- a[prop])
}
export default {
	state: {
        historyData:{
            starttime:getRecentSevenDay()[0].slice(0,10),
            endtime:getRecentSevenDay()[1].slice(0,10),
            bmcid:null,
        },
        histroyMap:{},
        productTable:[],
        productProps:[],
        scopeMapSelect:[],
        shopMapSelect:[],
        historyLoading:true
	},

	getters: {
        historyData:state=>{
            return state.historyData
        },
        histroyMap:state=>{
            return state.histroyMap
        },
        productTable:state=>{
            return state.productTable
        },
        productProps:state=>{
            return state.productProps
        },
        scopeMapSelect:state=>{
            return state.scopeMapSelect
        },
        shopMapSelect:state=>{
            return state.shopMapSelect
        }

	},

	mutations: {
        changeHistoryLoading(state,payload){
            state.historyLoading=payload
        },
		changeHistoryData(state,payload) {
            let data= {
                starttime:'',
                endtime:'',
                bmcid:null,
            }
			if(payload===0){
                //近七天
                data.starttime=getRecentSevenDay()[0].slice(0,10)
                data.endtime=getRecentSevenDay()[1].slice(0,10)

            }else if(payload===1){
                //近30天
                data.starttime=getRecentOneMonth()[0].slice(0,10)
                data.endtime=getRecentOneMonth()[1].slice(0,10)

            }else{
                //近90天
                data.starttime=getSinceThreeMonth()[0].slice(0,10)
                data.endtime=getSinceThreeMonth()[1].slice(0,10)
            }
            state.historyData=data
        },
        setHistoryData(state,payload){
            state.histroyMap=payload
        },
        setProductTable(state,payload){
            state.productTable=payload
        },
        setProductProps(state,payload){
            state.productProps=payload
        },
        setScopeMapSelect(state,payload){
            state.scopeMapSelect=payload
        },
        setshopMapSelect(state,payload){
            state.shopMapSelect=payload
        }
	},

	actions: {
        reqGetHistoryTrend ( { commit ,state}){
            return new Promise((r, j) => {
                fetchGet("/hcm/wechat/getHistoryTrend",state.historyData).then(res => {
                    if (res.status === "10000") {
                        commit('setHistoryData', res.data);
                        r()
                    }
                }).catch(()=>{
                    j()
                })
            })
        },
        getTableByToday({ commit ,state},data){
            fetchGet("/hcm/hcmNewMonitorProduct/getTableByToday",data).then(res=>{
                if (res.status === "10000"){
                    let arr
                    if(data.type){
                        arr=[
                            { prop:'platform', label:'平台'},
                            { prop:'notislowprice', label:'非违规链接',width:120},
                            { prop:'islowprice', label:'违规链接',width:120},
                            { prop:'updatetime', label:'数据更新时间',width:180},
                        ]
                    }else{
                        arr=[
                            { prop:'productname', label:'已监控产品'},
                            { prop:'itemlinkcount', label:'对应链接',width:80},
                            { prop:'islowprice', label:'违规链接',width:80},
                            { prop:'updatetime', label:'数据更新时间',width:180},
                        ]
                    }
                    
                    commit('setProductTable', timeSort(res.data,'updatetime'));
                    commit('setProductProps', arr);
                }
            })
        },
        getLowpriceTrend({ commit ,state}){
            fetchGet("/hcm/hcmNewMonitorProduct/getLowpriceTrend",state.historyData).then(res=>{
                if (res.status === "10000"){
                    let arr=[
                        {prop:'date',label:'时间',width:180}
                    ]
                    let head=res.data.head
                    for(let key in head){
                        arr.push({
                            prop:key,
                            label:head[key],
                        })
                    }
                    commit('setProductTable', timeSort(res.data.list,'date'));
                    commit('setProductProps', arr);
                }
            })
        },
        getTableByPlatformScope({ commit ,state}){
            fetchGet("/hcm/hcmNewMonitorProduct/getTableByPlatformScope",state.historyData).then(res=>{
                if (res.status === "10000"){
                    let arr=[
                        {prop:'date',label:'时间',width:180},
                        {prop:'all',label:'全部平台'},
                        {prop:'TB',label:'淘宝'},
                        {prop:'TM',label:'天猫'},
                        {prop:'JD',label:'京东'},
                        {prop:'SN',label:'苏宁'},
                        {prop:'PDD',label:'拼多多'}
                    ]

                  
                    commit('setProductTable', timeSort(res.data,'date'));
                    commit('setProductProps', arr);
                }
            })
        },
        getTableShopByProduct({ commit ,state},productid) {
            let data=state.historyData
            data.productid=productid
            fetchGet("/hcm/hcmNewMonitorProduct/getTableShopByProduct",data).then(res=>{
                if (res.status === "10000"){
                    commit('setProductTable', timeSort(res.data.list,'date'));
                    commit('setProductProps', createProp(res.data.head));
                }
            })
        },
        getTableLowpriceScopeByProduct({ commit ,state},productid) {
            let data=state.historyData
            data.productid=productid
            fetchGet("/hcm/hcmNewMonitorProduct/getTableLowpriceScopeByProduct",data).then(res=>{
                if (res.status === "10000"){
                    let head=res.data.head
                    let Newhead=[]
                    head.forEach(item => {
                        Newhead.push({
                            prop:item.mapper,
                            label:item.title
                        })
                    });
                    commit('setProductTable', timeSort(res.data.list,'date'));
                    commit('setProductProps', Newhead);
                }
            })
        }     

		
	},
}